import { KatBadge } from "@amzn/katal-react";
import React, { type FC } from "react";
import { ValidationSeverity } from "src/api/interfaces/nest";
import type { NestTestResultError } from "src/api/interfaces/nest/history";
import type { DataTableCellChildComponentProps } from "src/components/DataTable/DataTableDefinition";

const severityVariant = (s: string) =>
  s === ValidationSeverity.ERROR
    ? "danger"
    : s === ValidationSeverity.WARNING
      ? "warning"
      : "info";

const NestErrorSeverityCell: FC<
  DataTableCellChildComponentProps<NestTestResultError>
> = ({ content }) => {
  return (
    <KatBadge
      label={content.severity}
      type={severityVariant(content.severity)}
    />
  );
};

export default NestErrorSeverityCell;
